
import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'app-lc-proposal-view',
	templateUrl: './lc-proposal-view.component.html'
})

export class LcProposalViewComponent implements OnInit {

	@Input('accountClientID') accountClientID: string = "";
	@Input('profileUser') profileUser: string = "";
	@Input('proposalIDclosed') proposalIDclosed: string = "";
	@Input('currentClientDocument') currentClientDocument: string = "";
	@Input('segmentoID') segmentoID: string = "";
	@Input('tempGroup') tempGroup: any[] = [];

	constructor() {
	}

	ngOnInit() {
		console.log(this.accountClientID);
		console.log(this.profileUser);
		console.log(this.tempGroup);
	}

}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/proposal-view-modal/LCproposal-view/lc-proposal-view.component.ts